import React from 'react';
import { colors } from 'design-system';
import VectorIcon from './VectorIcon';
import IconProps from './IconProps';

const YourPolicyIcon = ({
  width = 56,
  height = 57,
}: IconProps): JSX.Element => (
  <VectorIcon width={width} height={height}>
    <circle
      cx="28"
      cy="28.9062"
      r="26"
      fill="#0D2E68"
      stroke="url(#paint0_linear_11785:48006)"
      strokeWidth="4"
    />
    <path
      d="M39.0418 19.1665C37.1535 18.6625 35.3086 18.0076 33.5252 17.2082C31.7705 16.447 30.0767 15.5528 28.4585 
    14.5332L28.0002 14.2498L27.5502 14.5415C25.932 15.5611 24.2381 16.4554 22.4835 17.2165C20.6971 18.0135 18.8495 
    18.6657 16.9585 19.1665L16.3335 19.3248V26.2748C16.3335 37.4332 27.6085 41.6082 27.7168 41.6498L28.0002 
    41.7498L28.2835 41.6498C28.4002 41.6498 39.6668 37.4415 39.6668 26.2748V19.3248L39.0418 19.1665ZM35.2335 
    24.7082L25.9252 33.7498L20.6585 28.4748C20.4375 28.2538 20.3133 27.9541 20.3133 27.6415C20.3133 27.329 
    20.4375 27.0292 20.6585 26.8082C20.8795 26.5872 21.1793 26.463 21.4918 26.463C21.8044 26.463 22.1041 
    26.5872 22.3252 26.8082L25.9502 30.4998L33.6085 22.9998C33.7179 22.8904 33.8478 22.8036 33.9908 
    22.7444C34.1338 22.6852 34.2871 22.6547 34.4418 22.6547C34.5966 22.6547 34.7498 22.6852 34.8928 
    22.7444C35.0358 22.8036 35.1657 22.8904 35.2752 22.9998C35.3846 23.1093 35.4714 23.2392 35.5306 
    23.3822C35.5899 23.5252 35.6203 23.6784 35.6203 23.8332C35.6203 23.9879 35.5899 24.1412 35.5306 
    24.2842C35.4714 24.4272 35.3846 24.5571 35.2752 24.6665L35.2335 24.7082Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_11785:48006"
        x1="28"
        y1="4.90625"
        x2="28"
        y2="52.9062"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={colors.bright_turquoise} />
        <stop offset="1" stopColor="#CEE8FF" />
      </linearGradient>
    </defs>
  </VectorIcon>
);

export default YourPolicyIcon;
